define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var i18n = require('i18n');
    var userValidation = require('modules/user/user.validation.config');

    module.exports = function() {

        var validationConfig = userValidation();

        validationConfig.zip.fn.fn = function($inputs) {
            var zip = $inputs.val().replace(/\s/g, '');
            var postcodeRe = /^[a-zA-Z0-9-/\#_s*]*$/; // regexp from reg. builder

            $inputs.val(zip);

            return postcodeRe.test(zip);
        };

        validationConfig.phoneWithArea.fn.fn = function($inputs) {
            var originPhoneValue = $inputs.map(_.property('value')).join('').trim();
            var phone = originPhoneValue.replace(/\+/g, '');
            var area = _.find($inputs, function(input) {
                return input.name === 'cellphone_area';
            });
            var areaValue;

            if (area) {
                areaValue = area.value.trim().replace(/\+/g, '');
                if (areaValue.length < 1 || areaValue.length > 4) {
                    this.message = i18n.t('playtech.mobile.system.user.tooltip.area.length');
                    return false;
                }
            }

            if (!phone) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.required');
                return false;
            }

            if (phone.length < 10 || phone.length > 12) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.length');
                return false;
            }

            return /^\+?[0-9]+$/.test(originPhoneValue);
        };

        return validationConfig;
    };
});
